export default __webpack_public_path__ + "static/media/what-nodejs-can-do.d0a3c84c.md";